module.exports = __webpack_public_path__ + "public/images/generated-learn-french.918c48e9a60d55f6aedaefe7005fd9ca.jpg";